<button
  type="button"
  class="user-bottom-sheet-trigger"
  [class.user-bottom-sheet-trigger--active]="isOpen()"
  [attr.data-cy]="dataCy()"
  [attr.aria-label]="'Abrir menu do usuário'"
  [attr.aria-expanded]="isOpen()"
  (click)="openSheet()">
  <lkt-avatar
    class="user-bottom-sheet-trigger__avatar"
    [src]="userAvatar()"
    [name]="userName()"
    size="x-small"
    shape="circle"
    [alt]="userName()">
  </lkt-avatar>
  <span class="user-bottom-sheet-trigger__label">{{ label() }}</span>
</button>

<!--
  `hasMultipleProfiles` é o input do design-system que governa a VISIBILIDADE do controle de troca de
  perfil dentro do bottom-sheet. A condição ligada nele agora inclui a trava do CA04, por isso ele
  recebe `canSwitchProfile()` e não `hasMultipleProfiles()` — reverter faz o controle voltar a
  aparecer na sessão personificada. O rename foi adiado e está registrado como dívida no README.md, seção
  "Dívida Arquitetural Conhecida" (entrada `hasMultipleProfiles`), com as condições para fazê-lo.
-->
<lkt-user-bottom-sheet
  [visible]="isOpen()"
  [userName]="userName()"
  [userAvatar]="userAvatar()"
  [profileLabel]="profileLabel()"
  [profileIcon]="profileIcon()"
  [hasMultipleProfiles]="canSwitchProfile()"
  [items]="userPopoverItems()"
  [version]="appVersion()"
  [dataCy]="dataCy() + '-sheet'"
  (visibleChange)="onVisibleChange($event)"
  (itemClick)="onItemClick($event)"
  (switchProfileClick)="onSwitchProfileClick()">
</lkt-user-bottom-sheet>
